<template>
  <i-select :model="statuses" multiple :value="value" :clearable="true" @input="input">
    <i-option
      v-for="(item, key) in type_answer"
      :key="key"
      :value="item"
      :label="$t(`pbx.stat.type_answer.${item}`)"
    />
  </i-select>
</template>

<script>
  const type_answer = ['ANSWERED', 'FAILED', 'CANCELED', 'REJECTED', 'NO_ANSWER'];
  export default {
    props: {
      value: {
        type: [String, Array],
        default: '',
        validator: function(value) {
          if (value) {
            return type_answer.indexOf(value) !== -1;
          }
          return true;
        }
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      type_answer: type_answer,
      statuses: null
    }),
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
